






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {Rastreamento} from '@/model/resource/Rastreamento'
import {InputRastreamentoSchema} from '@/schema/resource/Rastreamento/InputRastreamentoSchema'

@Component
export default class PersistRastreamentoView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputRastreamentoSchema()
  rastreamento = new Rastreamento()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.rastreamento.getRastreamento(id)
    }

    $.await.done('getRastreamento')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.rastreamento.persistRastreamento()
    await Helper.successAndPush('system.success.persist', '/rastreamento/list')
  }
}
